import { render, staticRenderFns } from "./UseAnotherAccount.vue?vue&type=template&id=372d9712&scoped=true"
import script from "./UseAnotherAccount.vue?vue&type=script&lang=js"
export * from "./UseAnotherAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372d9712",
  null
  
)

export default component.exports